module.exports = __webpack_public_path__ + "static/media/OldManInDingy.2f206b3d.jpg";